// @flow
import React from 'react'
import alertStore from 'stores/alert'
import styled from 'styled-components'
import {observer} from 'mobx-react'

export default observer(function Alert(){
  if(!alertStore.msg) return null
  const msg = alertStore.msg
  const handleOkClick = () => {
    alertStore.close()
    msg.onOk && msg.onOk()
  }
  const handleAbortClick = () => {
    alertStore.close()
    msg.onAbort && msg.onAbort()
  }
  return (
    <Wrapper>
      <Panel>
        <Title>{msg.title}</Title>
        <Message>{msg.body}</Message>
        <ButtonList>
          {msg.onOk && <Button onClick={handleOkClick}>OK</Button>}
          <Button red onClick={handleAbortClick}>Abbrechen</Button>
        </ButtonList>
      </Panel>
    </Wrapper>
  )
})

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: rgba(0,0,0,0.8);
`

const Title = styled.h2`
    text-align: center;
`

const Panel = styled.div`
    margin: 50px auto;
    border: 1px solid grey;
    background: white;
    width: 500px;
    padding: 20px;
`

const Message = styled.div`
    text-align: center;
    padding-bottom: 40px;
`

const ButtonList = styled.div`
    display: flex;
`

const Button = styled.div`
    flex: 1;
    background: ${props => props.red ? '#e91e63' : 'rgb(0, 150, 136)' };
    padding: 5px;
    text-align: center;
    margin: 5px;
    cursor: pointer;
`


// WEBPACK FOOTER //
// ./src/components/Alert.js